import AppSelect from '@/components/AppSelect';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import { Col, DatePicker, Form, Input, Row } from 'antd';
import dayjs from 'dayjs';
import ItemList from './ItemList';

const filterOptions = [
	// {
	// 	label: 'Default',
	// 	value: 'DEFAULT',
	// },
	{
		label: 'Campaign',
		value: 'CAMPAIGN',
	},
];

export default function FormItem({
	form,
	START_DATE,
	END_DATE,
	dataDefault,
	handleSubmitItem,
	pendingItems,
	isCreate
}) {
	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);
	const themeType = Form.useWatch('themeType', form);
	const isDefaultTheme = themeType === 'DEFAULT';

	return (
		<Row gutter={16}>
			{isDefaultTheme ?
				<>
					<Col span={isMobile ? 24 : 12}>
						<Form.Item
							label="Theme Name"
							name="themeName"
							rules={[{ required: true, message: 'Please enter theme name' }]}
						>
							<Input placeholder="Enter theme name" />
						</Form.Item>
					</Col>
					<Col span={isMobile ? 24 : 12}>
						<Form.Item
							label="Description"
							name="description"
							rules={[{ required: true, message: 'Please enter description' }]}
						>
							<Input placeholder="Enter description" />
						</Form.Item>
					</Col>

					{/* Field ẩn — giữ đăng ký & giá trị trong form, tránh bị unregister gây reset -> loop */}
					<Form.Item name="themeType" hidden>
						<Input />
					</Form.Item>
					<Form.Item name="period" hidden>
						<Input />
					</Form.Item>
				</>
				:
				<>
					<Col span={isMobile ? 24 : 12}>
						<Form.Item
							label="Theme Name"
							name="themeName"
							rules={[{ required: true, message: 'Please enter theme name' }]}
						>
							<Input placeholder="Enter theme name" />
						</Form.Item>
						<Form.Item
							label="Description"
							name="description"
							rules={[{ required: true, message: 'Please enter description' }]}
						>
							<Input placeholder="Enter description" />
						</Form.Item>
					</Col>
					<Col span={isMobile ? 24 : 12}>
						<Form.Item
							label="Theme Type"
							name="themeType"
							initialValue="CAMPAIGN"
							rules={[{ required: true, message: 'Please enter type' }]}
						>
							<AppSelect
								items={filterOptions?.map((item) => ({ value: item.value, label: item.label }))}
								formItemClassName="mb-0"
								placeholder="Select type"
							/>
						</Form.Item>
						<Form.Item
							label="Period"
							name="period"
							rules={[{ required: true, message: 'Please select period' }]}
							initialValue={{ startTime: START_DATE, endTime: END_DATE }}
						>
							<Row gutter={8} className="flex-nowrap items-start justify-between">
								<Col span={11}>
									<Form.Item
										name="startTime"
										className="mb-0"
										getValueFromEvent={(value) => value?.format('YYYY-MM-DD')}
										getValueProps={(value) => ({ value: value ? dayjs(value) : undefined })}
										rules={[{ required: true, message: 'Please select start date' }]}
										initialValue={START_DATE}
									>
										<DatePicker
											placeholder="Start Date"
											format="DD/MM/YYYY"
											className="w-full"
											onChange={() => form.validateFields(['endTime'])}
										/>
									</Form.Item>
								</Col>
								<Col className="text-center flex items-center">
									<span style={{ paddingTop: 4 }}>to</span>
								</Col>
								<Col span={11}>
									<Form.Item
										name="endTime"
										className="mb-0"
										getValueFromEvent={(value) => value?.format('YYYY-MM-DD')}
										getValueProps={(value) => ({ value: value ? dayjs(value) : undefined })}
										rules={[
											{ required: true, message: 'Please select end date' },
											{
												validator: (_, value) => {
													if (!value) return Promise.resolve();
													const startDate = form.getFieldValue('startTime');
													if (!startDate) return Promise.resolve();
													const start = dayjs(startDate);
													const end = dayjs(value);
													if (end.isBefore(start, 'd')) {
														return Promise.reject(new Error('End date cannot be before start date'));
													}
													return Promise.resolve();
												},
											},
										]}
										initialValue={END_DATE}
									>
										<DatePicker
											placeholder="End Date"
											format="DD/MM/YYYY"
											className="w-full"
											disabledDate={(current) => {
												const startDate = form.getFieldValue('startTime');
												const currentDate = dayjs(current);
												if (!startDate) return false;
												return current && currentDate.isBefore(dayjs(startDate), 'd');
											}}
										/>
									</Form.Item>
								</Col>
							</Row>
						</Form.Item>
					</Col>
				</>
			}
			<ItemList
				list={dataDefault}
				handleSubmitItem={handleSubmitItem}
				pendingItems={pendingItems}
				form={form}
				isCreate={isCreate}
			/>
		</Row >
	)
}
